import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, FloatingLabel, Spinner } from 'react-bootstrap';
import Styles from '../../styles/authentication/forgotpassword.module.css';
import { useNavigate } from 'react-router-dom';
import { ForgetPassHelper } from '../../helpers/auth/forget-password';
import { Helmet } from 'react-helmet';

const ForgotPassword: React.FC = () => {
  const {
    formErrors,
    values,
    handleForgotPassword,
    handleChange,
    isProcessing,
  } = ForgetPassHelper();

  const navigate = useNavigate();

  // Separate states for each label's active state
  const [emailActive, setEmailActive] = useState(false);


  return (
    <>
      <Helmet>
        <title>Forgot Password - Mohit's Shopping App</title>
        <meta
          name="description"
          content="Reset your password for Mohit's Shopping App to regain access to your account and start shopping again."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta property="og:title" content="Forgot Password - Mohit's Shopping App" />
        <meta
          property="og:description"
          content="Forgot your password? Reset it here to regain access to your account on Mohit's Shopping App and continue exploring great deals."
        />
        <meta
          property="og:image"
          content={`${process.env.PUBLIC_URL}/favicon.png`}
        />
        <meta
          property="og:url"
          content="https://mohit-online-shopping.netlify.app/forgot-password"
        />
      </Helmet>

      {/* Main Heading of the Forgot Password Page */}
      <h1 className="visually-hidden">Forgot Password - Reset Your Account Password</h1>

      <section className={Styles.forgotPasswordSec}>
        <Container fluid className={Styles.container}>
          <Row className={`justify-content-left ${Styles.row}`}>
            <Col className={`d-flex align-items-center justify-content-center ${Styles.col}`} md={6}>
              <div className={Styles.formWrapper}>
                <h1>Forgot Password</h1>
                <Form onSubmit={handleForgotPassword}>
                  <Form.Group>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Your Email"
                      className={`${Styles.floatingLabel} ${emailActive ? Styles.floatingLabelActive : ''}`}
                    >
                      <Form.Control
                        type="email"
                        placeholder="Email"
                        name="email"
                        className={Styles.input}
                        autoComplete="off"  // Use camelCase for JSX
                        onFocus={() => setEmailActive(true)}
                        onBlur={(e) => setEmailActive(e.target.value !== '')}
                        value={values.email}
                        onChange={handleChange}
                        disabled={isProcessing} // Disable when processing
                      />
                    </FloatingLabel>
                  </Form.Group>
                  <Button
                    type="submit"
                    className={Styles.forgotPasswordBtn}
                    disabled={isProcessing}>
                    {Object.keys(formErrors).length > 0 ? (
                      'Send Otp'
                    ) : isProcessing ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className={Styles.customSpinner} // Applying custom spinner styles here
                      />
                    ) : (
                      'Send Otp'
                    )}
                  </Button>
                  <p className={Styles.text}>
                    Remembered your password?
                    <b className={Styles.pointer} onClick={() => navigate('/auth/sign-in')}> Sign in here</b>
                  </p>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ForgotPassword;
